import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Card,
  Modal,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../assets/css/KheloJito.css";
import axios from "axios";
import FooterPage from "../footer/FooterPage";
import RegisFeeImage from "../../assets/images/img-regi.png";


function RegisFee() {
 
  const location = useLocation();

  // Get course data from location state (if navigated from Courses page)
  const courseData = location?.state?.courseData || null;
  const isCourseRegistration = !!location?.state?.courseData;

  // State to hold the form data
  const [formData, setFormData] = useState({
    phone: "",
    full_name: "",
    email: "",
    fee: 0,
  });

  const [apiFee, setApiFee] = useState(null);

  useEffect(() => {
    const fetchFee = async () => {
      try {
        const response = await axios.get(
          "https://brainrock.in/brainrock/backend/api/fee-item/",
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        
        const feeValue = response.data.data[0].fee;
        setApiFee(feeValue);
        setFormData((prev) => ({ ...prev, fee: feeValue }));
      } catch (error) {
        console.error("Error fetching fee:", error);
        setApiFee(8);
        setFormData((prev) => ({ ...prev, fee: 8 }));
      }
    };
    fetchFee();
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

const [selectedCategory, setSelectedCategory] = useState("");
  const [courseId, setCourseId] = useState("");
   const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (courseData) {
      setCourseId(courseData.course_id || courseData.id || "");
      setSelectedCategory(courseData.category || "");
    }
  }, [courseData]);

   useEffect(() => {
     const fetchCourses = async () => {
       try {
         const response = await axios.get(
           "https://brainrock.in/brainrock/backend/api/course-list/",
           {
             withCredentials: true,
             headers: {
               "Content-Type": "application/json",
             },
           }
         );
         setCategories(response.data.courses || []);
       } catch (error) {
         console.error("Error fetching courses:", error);
       }
     };
     fetchCourses();
   }, []);

  const navigate = useNavigate();

  // Handler for input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    validateField(name, value);
  };

  // Validation for form fields
  const validateField = (name, value) => {
    let msg = "";

    switch (name) {
      case "full_name":
        if (!value.trim()) msg = "Full name is required";
        break;

      case "email":
        if (!value.trim()) msg = "Email is required";
        else if (!/^\S+@\S+\.\S+$/.test(value)) msg = "Invalid email format";
        break;

      case "phone":
        if (!value.trim()) msg = "Phone number is required";
        else if (!/^[0-9]{10}$/.test(value))
          msg = "Phone number must be 10 digits";
        break;

      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [name]: msg }));
    return msg === "";
  };

  // Validate entire form before submission
  const validateFormBeforeSubmit = () => {
    let temp = {};
    let isValid = true;

    if (!formData.full_name) {
      temp.full_name = "Full name is required";
      isValid = false;
    }

    if (!formData.email) {
      temp.email = "Email is required";
      isValid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      temp.email = "Invalid email format";
      isValid = false;
    }

    if (!formData.phone) {
      temp.phone = "Phone number is required";
      isValid = false;
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      temp.phone = "Phone number must be 10 digits";
      isValid = false;
    }

    setErrors(temp);
    return isValid;
  };

  // Actual form submission logic
  const handleActualSubmit = async () => {
    if (!validateFormBeforeSubmit()) return;

    setIsLoading(true);
    setShowError(false);
    setShowSuccess(false);

try {
       const submitData = {
         full_name: formData.full_name,
         email: formData.email,
         phone: formData.phone,
         fee: apiFee || 8,
         course_id: courseId || "",
         category: selectedCategory || ""
       };

      const response = await axios.post(
        "https://brainrock.in/brainrock/backend/api/register-test/",
        submitData
      );

      console.log("Registration successful:", response.data);
      console.log("User ID:", response.data.user_id);

      // Store user_id, phone number, and source in localStorage
      localStorage.setItem("test_user_id", response.data.user_id);
      localStorage.setItem("test_user_phone", formData.phone);
      localStorage.setItem("test_source", isCourseRegistration ? "course_registration" : "khelojito");

      // Store course data in localStorage for recovery
      if (isCourseRegistration && courseData) {
        localStorage.setItem("test_courseData", JSON.stringify(courseData));
        localStorage.setItem("test_courseId", courseData.course_id || courseData.id);
      }

      // Clear previous test progress to ensure the new registration starts fresh
      const testKeys = [
        "test_currentQuestion", "test_score", "test_showResults", 
        "test_userAnswers", "test_timeLeft", "test_testResult",
        "test_tabSwitchWarning", "test_tabSwitchCount", "test_showWinnerForm",
        "test_showWrongAnswersModal", "test_wrongAnswers", "test_certificateUrl",
        "test_showInstructionsModal"
      ];
      testKeys.forEach(key => localStorage.removeItem(key));

      // Clear form
      setFormData({ full_name: "", email: "", phone: "", fee: apiFee || 8 });

      // Open payment in new tab, navigate current tab to test
      if (
        response.data.payment_order &&
        response.data.payment_order.redirectUrl
      ) {
        window.open(response.data.payment_order.redirectUrl, "_blank");
      }
      if (isCourseRegistration) {
        window.location.href = `/CoursesTest?user_id=${response.data.user_id}`;
      } else {
        navigate("/Test");
      }
    } catch (error) {
      console.error("Error during registration:", error);

      if (error.response && error.response.data) {
        const apiErrors = {};

        if (error.response.data.email) {
          apiErrors.email = error.response.data.email[0];
        }

        if (error.response.data.phone) {
          apiErrors.phone = error.response.data.phone[0];
        }

        if (Object.keys(apiErrors).length > 0) {
          setErrors((prev) => ({ ...prev, ...apiErrors }));
        } else if (error.response.data.message) {
          setErrorMessage(error.response.data.message);
          setShowError(true);
        } else if (typeof error.response.data === "string") {
          setErrorMessage(error.response.data);
          setShowError(true);
        }
      } else {
        setErrorMessage(
          "Registration failed. Please check your connection and try again.",
        );
        setShowError(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Handler for form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    await handleActualSubmit();
  };

  return (
    <>
      {/* Banner Section */}
      <div className="Services-banner">
        
      </div>

        <div className="khelojito-section">
         <Container fluid className="mt-4 mb-3">
           {isCourseRegistration && (
                <Button
                  variant="outline-secondary"
                  className="br-button mb-3"
                  onClick={() => navigate("/Courses")}
                >
                  ← Back to Courses
                </Button>
              )}
          <Row className="align-items-stretch justify-content-center">
            <Col xs={12} md={5} className="mb-4 mb-md-0 d-flex">
             
              <div className="khelo-image-container flex-grow-1">
                <img
                  src={RegisFeeImage}
                  alt="Khelo aur Jeeto"
                  className="khelo-image"
                />
              </div>
            </Col>

            <Col xs={12} md={5} className="d-flex">
              <div className="khelojito-box text-heading flex-grow-1">
            {/* Success Alert */}

            {showSuccess && (
              <Card className="mb-4 border-success success-card">
                <Card.Body className="text-center">
                  <Card.Title className="text-success mt-3">
                    Registration Successful!
                  </Card.Title>
                  <Card.Text>
                    Thank you for registering! You will be redirected to the
                    test page shortly.
                  </Card.Text>
                </Card.Body>
              </Card>
            )}

            {/* Error Alert */}
            {showError && (
              <Alert
                variant="danger"
                onClose={() => setShowError(false)}
                dismissible
              >
                {errorMessage}
              </Alert>
            )}

            {/* Registration Form */}
            <Form onSubmit={handleSubmit}>
              <Row>
                {/* Phone Number */}
                <Col md={6} className="mt-3">
                  <Form.Group>
                    <Form.Label className="br-label">
                      Phone Number <span className="br-span-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="tel"
                      className={`br-form-control ${errors.phone ? "is-invalid" : ""}`}
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="Enter your phone number"
                    />
                    {errors.phone && (
                      <div className="invalid-feedback">{errors.phone}</div>
                    )}
                  </Form.Group>
                </Col>

                {/* Full Name */}
                <Col md={6} className="mt-3">
                  <Form.Group>
                    <Form.Label className="br-label">
                      Full Name <span className="br-span-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className={`br-form-control ${errors.full_name ? "is-invalid" : ""}`}
                      name="full_name"
                      value={formData.full_name}
                      onChange={handleInputChange}
                      placeholder="Enter your full name"
                    />
                    {errors.full_name && (
                      <div className="invalid-feedback">{errors.full_name}</div>
                    )}
                  </Form.Group>
                </Col>

                {/* Email */}
                <Col md={6} className="mt-3">
                  <Form.Group>
                    <Form.Label className="br-label">
                      Email <span className="br-span-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      className={`br-form-control ${errors.email ? "is-invalid" : ""}`}
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Enter your email"
                    />
                    {errors.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
                  </Form.Group>
                </Col>

                {/* Category Dropdown */}
                <Col md={6} className="mt-3">
                  <Form.Group>
                    <Form.Label className="br-label">
                      Category <span className="br-span-star">*</span>
                    </Form.Label>
<Form.Select
                       className={`br-form-control ${errors.course_category ? "is-invalid" : ""}`}
                       name="course_category"
                       value={selectedCategory}
                       onChange={(e) => setSelectedCategory(e.target.value)}
                     >
                       <option value="">Select Category</option>
                       {categories.map((course) => (
                         <option key={course.id} value={course.course_name}>
                           {course.course_name}
                         </option>
                       ))}
                     </Form.Select>
                    {errors.course_category && (
                      <div className="invalid-feedback">{errors.course_category}</div>
                    )}
                  </Form.Group>
                </Col>

                <Form.Group className="mt-3">
                  <Form.Check
                    type="checkbox"
                    label={
                      <>
                        I agree to the <a href="#" onClick={(e) => {
                          e.preventDefault();
                          setShowTermsModal(true);
                        }}>Terms and Conditions</a>
                      </>
                    }
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                    className="br-checkbox"
                  />
                </Form.Group>
                {/* Submit Button */}
                <Col md={12} className="mt-4">
                  <Button
                    variant="primary"
                    type="submit"
                    className="br-button"
                    disabled={isLoading || !termsAccepted}
                  >
                    {isLoading ? "Registering..." : "Register"}
                  </Button>
                </Col>
              </Row>
            </Form>
              </div>
            </Col>
          </Row>

          {/* Terms and Conditions Modal */}
          <Modal 
            show={showTermsModal} 
            onHide={() => setShowTermsModal(false)}
            size="lg"
            centered
          >
            <Modal.Header closeButton className="term-nd-condi">
              <Modal.Title className="term-title">Terms and Conditions – Online Quiz Game</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <div className="terms-content">
                <p><strong>Last Updated: March 2026</strong></p>
                <p>Welcome to our Online Quiz Platform. By accessing or using this website and participating in the quiz game, you agree to comply with and be bound by the following Terms and Conditions. Please read them carefully before participating.</p>
                
                <h4> Acceptance of Terms</h4>
                <p>By registering on this platform and participating in the quiz game, the user agrees to follow all rules, policies, and conditions mentioned in these Terms and Conditions. If you do not agree with these terms, you should not use this platform.</p>
                
                <h4> Eligibility</h4>
                <ul>
                  <li>The quiz platform is open to users who are 13 years of age or older.</li>
                  <li>Users below 18 years of age must have permission from a parent or legal guardian to participate.</li>
                  <li>By registering, the user confirms that the information provided is accurate and that they meet the eligibility requirements.</li>
                  <li>The platform reserves the right to request age verification or parental consent if required.</li>
                </ul>
                
                <h4> Registration Fee</h4>
                <ul>
                  <li>To participate in the quiz game, users are required to pay a registration fee of ₹{apiFee !== null ? apiFee : '...'}</li>
                  <li>This registration fee is non-refundable once the quiz attempt has started.</li>
                  <li>Payment of the registration fee allows the user to participate in one quiz session unless stated otherwise.</li>
                </ul>
                
                <h4> Quiz Format</h4>
                <ul>
                  <li>The quiz consists of multiple-choice questions (MCQs).</li>
                  <li>Each question will have a set of options from which the participant must select the correct answer.</li>
                  <li>Participants must complete the quiz within the specified time limit.</li>
                  <li>Once an answer is submitted, it cannot be changed.</li>
                </ul>
                
                <h4> Reward System</h4>
                <ul>
                  <li>If a participant answers all questions correctly, 80 points will be credited to the user's game wallet.</li>
                  <li>Points represent the value within the platform wallet system.</li>
                  <li>Rewards are credited automatically after successful completion and verification of the quiz attempt.</li>
                </ul>
                
                <h4> Wallet System</h4>
                <ul>
                  <li>Each registered user will have a wallet within the platform.</li>
                  <li>Rewards earned through quizzes will be credited to this wallet.</li>
                  <li>Wallet balances are maintained digitally and can be viewed in the user dashboard.</li>
                  <li>The platform reserves the right to correct any technical errors in wallet balances.</li>
                </ul>
                
                <h4> Withdrawal Policy</h4>
                <ul>
                  <li>Users can request withdrawal only when the wallet balance reaches a minimum of ₹200.</li>
                  <li>Withdrawal requests will be processed through the payment methods supported by the platform.</li>
                  <li>The platform may require identity verification before processing withdrawals.</li>
                  <li>Withdrawal processing time may vary depending on payment provider processing.</li>
                </ul>
                
                <h4> Fair Play Policy</h4>
                <p>Users must participate fairly and must not:</p>
                <ul>
                  <li>Use bots, automated software, scripts, or external tools</li>
                  <li>Attempt to manipulate quiz results</li>
                  <li>Use unfair methods to gain advantage</li>
                  <li>Share answers with other participants during active quizzes</li>
                </ul>
                <p>Violation of fair play rules may result in account suspension, cancellation of winnings, or permanent ban.</p>
                
                <h4> Multiple Accounts Restriction</h4>
                <ul>
                  <li>Users are allowed to maintain only one account per person.</li>
                  <li>Creating multiple accounts to gain additional rewards or unfair advantage is strictly prohibited.</li>
                  <li>If duplicate accounts are detected, the platform reserves the right to suspend or terminate all associated accounts.</li>
                </ul>
                
                <h4> Fraud Prevention</h4>
                <p>The platform reserves the right to investigate any suspicious activity including:</p>
                <ul>
                  <li>unusual gameplay patterns</li>
                  <li>multiple accounts from the same device or IP</li>
                  <li>attempts to exploit system errors</li>
                </ul>
                <p>Accounts involved in fraudulent activities may be blocked and winnings may be cancelled.</p>
                
                <h4> Skill-Based Game Disclaimer</h4>
                <p>This quiz platform is designed as a knowledge and skill-based educational game. Winning depends on the participant’s ability to answer questions correctly and is not based on luck or chance.</p>
                
               
                
                <h4> Technical Issues</h4>
                <p>The platform is not responsible for issues arising from:</p>
                <ul>
                  <li>internet connectivity problems</li>
                  <li>device compatibility issues</li>
                  <li>temporary server downtime</li>
                </ul>
                <p>However, the platform will make reasonable efforts to ensure smooth service.</p>
                
                <h4> Account Responsibility</h4>
                <p>Users are responsible for maintaining the confidentiality of their login credentials. Any activity occurring through the user’s account will be considered the responsibility of the account holder.</p>
                
                <h4> Intellectual Property</h4>
                <p>All quiz questions, content, designs, logos, and materials on this website are the property of the platform and may not be copied, reproduced, or distributed without permission.</p>
                
                <h4> Modification of Terms</h4>
                <p>The platform reserves the right to update or modify these Terms and Conditions at any time. Continued use of the platform after such changes implies acceptance of the updated terms.</p>
                
                <h4> Account Suspension or Termination</h4>
                <p>The platform reserves the right to suspend or permanently terminate any user account that violates these Terms and Conditions or engages in suspicious or illegal activities.</p>
                
                <h4> Limitation of Liability</h4>
                <p>The platform shall not be liable for any losses, damages, or claims arising from the use of this website or participation in the quiz game.</p>
                
                <h4> Governing Law</h4>
                <p>These Terms and Conditions shall be governed by the laws of India. Any disputes arising shall fall under the jurisdiction of the competent courts in India.</p>

                <h4> Legal Compliance and State Restrictions</h4>
                <p>This platform operates as a skill-based game and does not involve gambling, betting, or games of chance. The platform complies with applicable Indian laws. Users are responsible for ensuring that participation is legal in their respective state.</p>
                <p>Users from states where participation in online real-money games is restricted or prohibited (such as Assam, Odisha, Telangana, Andhra Pradesh, and others as per applicable laws) are not allowed to participate.</p>
                <p>The platform does not guarantee any earnings or winnings. Rewards depend solely on the user’s performance and accuracy in the quiz.</p>
                <p>Points earned in the quiz are equivalent to wallet balance and may be converted into real money subject to platform policies.</p>

<h4> Terms and Conditions – Online Quiz Game for Training Courses</h4>
                 <p>Welcome to our Training Course Quiz. By accessing or using this quiz and registering for training courses, you agree to comply with and be bound by the following Terms and Conditions.</p>
                 
                 <h4> Quiz Participation and Discount</h4>
                 <ul>
                   <li>To be eligible for the 20% discount on training course fees, users must pass the online quiz with a minimum passing score.</li>
                   <li>The 20% discount is automatically applied to the course fee upon successful quiz completion.</li>
                   <li>Users must register with the same mobile number used during the quiz attempt to claim the discount.</li>
                   <li>The discount is valid for 30 days from the date of quiz completion.</li>
                   <li>The discount can only be claimed once per user per course.</li>
                   <li>If a user fails the quiz, they can retake it after registration to earn the discount.</li>
                 </ul>
                 
                 <h4> Contact Information</h4>
                 <p>For any queries or support, users can contact us at: admin@brainrock.in</p>
                 <p>Withdrawals processed within 3–7 working days.</p>

                 <div className="mt-4">
                  <Form.Check
                    type="checkbox"
                    label="I agree to the Terms and Conditions"
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                    className="mb-3"
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button 
                variant="secondary" className="agree-btn"
                onClick={() => {
                  setShowTermsModal(false);
                  setTermsAccepted(false);
                }}
              >
                Decline
              </Button>
              <Button 
                variant="primary" className="agree-btn"
                onClick={() => {
                  setShowTermsModal(false);
                  setTermsAccepted(true);
                }}
              >
                I Agree
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </div>

      <Container fluid className="br-footer-box">
        <FooterPage />
      </Container>
    </>
  );
}

export default RegisFee;
